var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-3 mb-3 text-xs md:text-sm text-error-10 bg-error-bg rounded-lg border border-gray-26 flex gap-2 items-start",attrs:{"test-id":"notification"}},[_c('span',{attrs:{"test-id":"icon"}},[_c('alert-icon',{attrs:{"color":"#D71841"}})],1),_c('div',{staticClass:"text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }